import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

import { select } from '@js/util/select.js'

select('.shared-swiper', swiperElement => {
  swiperElement.classList.remove('not-initialized')

  const options = JSON.parse(swiperElement.dataset.swiperOptions || '{}')

  const swiper = new Swiper(swiperElement.querySelector('.swiper'), {
    modules: [A11y, Navigation],

    a11y: {
      enabled: true,
    },

    navigation: {
      prevEl: swiperElement.querySelector('.swiper-button-prev'),
      nextEl: swiperElement.querySelector('.swiper-button-next'),
    },

    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 'auto',
    threshold: 5,
    centeredSlides: false,

    ...options,
  })

  swiperElement.classList.toggle('swiper-locked', swiper.isLocked)

  swiper.on('lock', () => {
    swiperElement.classList.add('swiper-locked')
  })

  swiper.on('unlock', () => {
    swiperElement.classList.remove('swiper-locked')
  })

  return () => {
    swiper.destroy()
  }
})
